import React, { PureComponent } from 'react'
import { Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import DirectionOUModalPage from '../../../containers/masters/DirectionOUModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DirectionUOMaster extends PureComponent {
  componentDidMount () {
    this.props.actions.fetchDirectionUOMaster()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDirectionUOMaster({ ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDirectionUOMaster({ ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  render () {
    const {
      t, sourceDirectionsList, pagesCount, directionsUOCount, filter,
      filter: { page },
      actions: { deleteDirectionUOModal, openDirectionUOModal, fetchDirectionUOMaster }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'directionUOMasterPage' })
    const tKey = 'MASTERS.DIRECTION_OU_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    return (
      <div id="directionUOMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openDirectionUOModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">

            </div>
          </div>

        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th
                      onClick={() => { this.changeOrder('directionUOId') }}
                    >
                      {t('MASTERS.ID')}
                      <i className={this.getSortIcon(t('MASTERS.ID'))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('description') }}
                    >
                      {t('MASTERS.DESCRIPTION')}
                      <i className={this.getSortIcon(t('MASTERS.DESCRIPTION'))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('address') }}
                    >
                      {t(`${tKey}ADDRESS`)}
                      <i className={this.getSortIcon(t(`${tKey}ADDRESS`))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('cp') }}
                    >
                      {t(`${tKey}CP`)}
                      <i className={this.getSortIcon(t(`${tKey}CP`))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('city') }}
                    >
                      {t(`${tKey}CITY`)}
                      <i className={this.getSortIcon(t(`${tKey}CITY`))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('state') }}
                    >
                      {t(`${tKey}STATE`)}
                      <i className={this.getSortIcon(t(`${tKey}STATE`))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('country') }}
                    >
                      {t(`${tKey}COUNTRY`)}
                      <i className={this.getSortIcon(t(`${tKey}COUNTRY`))} />
                    </th>
                    <th
                      onClick={() => { this.changeOrder('phone') }}
                    >
                      {t(`${tKey}PHONE`)}
                      <i className={this.getSortIcon(t(`${tKey}PHONE`))} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {sourceDirectionsList.map((direction, idx) => (
                    <tr key={idx}>
                      <td>{direction.directionUOId}</td>
                      <td>{direction.description}</td>
                      <td>{direction.address}</td>
                      <td>{direction.cp}</td>
                      <td>{direction.city}</td>
                      <td>{direction.state}</td>
                      <td>{direction.country}</td>
                      <td>{direction.phone}</td>
                      <td className='actions'>
                        <div>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <a className='_Btn accept stk o-icn ' onClick={() => openDirectionUOModal(direction.directionUOId)}>
                              <i className="iDocIcon-edit" />
                            </a>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <a className='_Btn cancel stk o-icn ' onClick={() => deleteDirectionUOModal(direction.directionUOId)}>
                              <i className="iDocIcon-delete-forever" />
                            </a>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_direction"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={directionsUOCount}
                    onSelectAction={(value) => fetchDirectionUOMaster({ ...filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <DirectionOUModalPage />
      </div>
    )
  }
}

export default DirectionUOMaster
